import gql from "graphql-tag";

//GetChildPermitCountByDateRange
export const GET_DASHBOARD_2_CHILD_COUNT_BY_DATE = gql`
    query ($startDate: String!, $endDate: String!, $childPermitType: String!, $sites: [String!]!) {
        GetChildPermitCountByDateRange(startDate: $startDate, endDate: $endDate, childPermitType: $childPermitType, sites: $sites) {
            code
            success
            message
            results {
                tableData {
                    title
                    childPermitType
                    approved
                    pendingClosure
                    completed
                    total
                }
            }
        }
    }
`;